import React from 'react'
import GoogleButton from 'components/GoogleButton'
import MicrosoftButton from 'components/MicrosoftButton'
import { fontWeight, Form, spacer } from 'stylist'
import styled from '@emotion/styled'

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  > * {
    margin-right: ${spacer(3)};
  }
`

const Label = styled.span`
  ${fontWeight('bold')};
`

const SSOProviderButtons = ({ cookiesAccepted, cookieError, isSignUp }) => (
  <Form.Field
    render={({ setFieldError }) => (
      <ButtonBox>
        <Label>Sign {isSignUp ? 'up' : 'in'} with:</Label>
        <GoogleButton
          valid={cookiesAccepted}
          onError={() => setFieldError('cookiesAccepted', cookieError)}
        />
        <MicrosoftButton
          valid={cookiesAccepted}
          onError={() => setFieldError('cookiesAccepted', cookieError)}
        />
      </ButtonBox>
    )}
  />
)

export default SSOProviderButtons



// WEBPACK FOOTER //
// ./src/components/SSOProviderButtons.js